var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarViewLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.14,
    height: 20,
    viewBox: "0 0 18.14 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_15_",
    "data-name": "calendar (15)",
    transform: "translate(1.75 1.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_409",
    "data-name": "Union 409",
    d: "M5.136,20a5.223,5.223,0,0,1-3.729-1.33A5.087,5.087,0,0,1,0,14.9V6.486A4.964,4.964,0,0,1,1.412,2.772,5.056,5.056,0,0,1,4.62,1.487V.7A.7.7,0,1,1,6.015.7V1.47h6.119V.7a.7.7,0,1,1,1.4,0v.789a5,5,0,0,1,3.285,1.359A5,5,0,0,1,18.14,6.488v8.486a4.982,4.982,0,0,1-1.408,3.717A5.266,5.266,0,0,1,13,20ZM1.4,14.9c0,2.386,1.328,3.7,3.74,3.7H13c2.413,0,3.74-1.29,3.74-3.63V8.283H1.4ZM16.744,6.887v-.4a3.594,3.594,0,0,0-.918-2.655,3.6,3.6,0,0,0-2.3-.945V3.76a.7.7,0,0,1-1.4,0v-.9H6.015v.9a.7.7,0,1,1-1.395,0V2.885A3.244,3.244,0,0,0,1.4,6.486v.4ZM13.2,15.531a.7.7,0,0,1,0-1.395h.009a.7.7,0,0,1,0,1.395Zm-4.127,0a.7.7,0,1,1,0-1.395h.008a.7.7,0,1,1,0,1.395Zm-4.136,0a.7.7,0,1,1,0-1.395h.008a.7.7,0,0,1,0,1.395ZM13.2,11.916a.7.7,0,0,1,0-1.395h.009a.7.7,0,0,1,0,1.395Zm-4.127,0a.7.7,0,1,1,0-1.395h.008a.7.7,0,1,1,0,1.395Zm-4.136,0a.7.7,0,1,1,0-1.395h.008a.7.7,0,0,1,0,1.395Z",
    transform: "translate(-1.75 -1.75)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarViewLight);
export default __webpack_public_path__ + "static/media/calendar_view_light.c2c02a993ecf8281b863fb39b716efe6.svg";
export { ForwardRef as ReactComponent };